import React from "react";
import styled from "styled-components";
import theme from "../../../theme";
import AllAdvertisers from "./Advertisers";
import AllPublishers from "./Publishers";
import { Link } from "react-router-dom";

const CardTab = ({ title, advertisers, publishers }) => {
  // const [activeTab, setActiveTab] = useState("All");

  // const tabs = ["All", "Active", "Inactive", "Top"];
  

  return (
    <Container>
      <div className="header">
        <h2>{title}</h2>
        <Link className="button" to={advertisers ? '/advertisers' : publishers ? '/publishers' : ''}>See more</Link>
      </div>
      {/* <Tabs>
        {tabs.map((tab) => (
          <Tab
            key={tab}
            isActive={activeTab === tab}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </Tab>
        ))}
      </Tabs> */}
      {advertisers && <AllAdvertisers/>}
      {publishers && <AllPublishers/>}

    </Container>
  );
};

export default CardTab;

// Styled Components
const Container = styled.div`
  width: 100%;
  padding: 24px;
  background: ${theme.color.surface};
  border: 1px solid ${theme.color.border};
  border-radius: ${theme.radius.lg};
  box-shadow: ${theme.shadow.sm};

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;

    h2 {
      font-size: ${theme.font.h3};
      font-weight: 600;
      color: ${theme.color.text};
    }

    .button {
      display: inline-flex;
      align-items: center;
      height: 36px;
      padding: 0 14px;
      border: 1px solid ${theme.color.borderStrong};
      border-radius: ${theme.radius.sm};
      background: ${theme.color.surface};
      cursor: pointer;
      font-size: ${theme.font.small};
      color: ${theme.color.text};
      text-decoration: none;
      white-space: nowrap;

      &:hover {
        background: ${theme.color.surfaceAlt};
      }
    }
  }
`;